import { initializeApp } from "firebase/app";
import { getFirestore, Timestamp } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFunctions } from "firebase/functions";


const firebaseConfig = {
  apiKey: "AIzaSyCHZwJ_VkR_8EEVbCZqSMqRMK00nWQdkvE",
  authDomain: "eyeary-544dd.firebaseapp.com",
  projectId: "eyeary-544dd",
  storageBucket: "eyeary-544dd.appspot.com",
  messagingSenderId: "1096053292936",
  appId: "1:1096053292936:web:7030cc7b9ee2958f1f043d",
  measurementId: "G-GKLSPZ8480"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const analytics = getAnalytics(app)
const firestore = getFirestore(app)
const functions = getFunctions(app)

const googleProvider = new GoogleAuthProvider();

// Export auth and Google provider
export { firestore, auth, functions, analytics, googleProvider };

export function timestampToDate(timestamp) {
  if (timestamp instanceof Date && !isNaN(timestamp)) return timestamp
  return timestamp.toDate()
}

export function dateToTimestamp(date = new Date()) {
  return Timestamp.fromMillis(date.getTime())
}

export function convertTimestampField(data, field = "timestamp") {
  data[field] = timestampToDate(data[field]).getTime()
  return data
}
